import React from 'react';
import styled from 'styled-components';

import { FlexBoxColumn } from '@ecp/common/src/layouts/flex/styled';
import Loading from '@ecp/common/src/components/progress/bo/Loading';

const SuspenseSpinner = () => {
  return (
    <Container>
      <Loading />
    </Container>
  );
};

const Container = styled(FlexBoxColumn)`
  width: 100%;
  height: 100vh;
  justify-content: center;
  background-color: transparent;
`;

export default SuspenseSpinner;
